var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"breadcrumb"},_vm._l(((_vm.$route.name.split('-'))),function(path){return _c('span',[_vm._v("\n      "+_vm._s(path.charAt(0).toUpperCase() + path.substring(1))+"\n      "),_c('i',{staticClass:"icon icon-icon_arrow-right"})])}),0),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.$route.meta.action))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bfa1685","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 843
// module chunks = 0